<template>
    <div class="footer-dashboard">

    </div>
</template>

<script>
    export default {
        name: 'Footer'
    }
</script>



// WEBPACK FOOTER //
// src/components/backend/templates/Footer.vue